import { enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, RouteReuseStrategy, withComponentInputBinding } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { IonicModule } from '@ionic/angular';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { httpInterceptorProviders } from './app/http-interceptors';
import { provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  BrandsEffects,
  BrandsFeatureKey,
  brandsReducer,
  CompaniesEffects,
  companiesFeatureKey,
  companiesReducer,
  ProductTypesEffects,
  productTypesFeatureKey,
  productTypesReducer,
  ProjectsEffects,
  projectsFeatureKey,
  projectsReducer,
  ItemConfigurationEffects,  
} from './app/state';
import { PricingInputsEffects, pricingInputsFeatureKey, pricingInputsReducer } from './app/state/pricing-inputs';
import { pricingFormFeatureKey, pricingFormReducer } from './app/state/pricing-form/pricing-form.reducer';
import { itemCodeStringValuesFeatureKey, itemCodeStringValuesReducer } from './app/state/item-code-strings';
import { itemConfigurationHeaderFeatureKey, itemConfigurationHeaderReducer, scheduleLineItemFeatureKey, scheduleLineItemReducer, itemConfigurationPerformanceFeatureKey, itemConfigurationPricingFeatureKey,  itemConfigurationPerformanceReducer, itemConfigurationPricingReducer } from './app/state/item-configuration/item-configuration.reducer';
import { ItemConfigurationInputEffects, itemConfigurationInputRequestFeatureKey, itemConfigurationInputRequestReducer, itemConfigurationInputResponseFeatureKey, itemConfigurationInputResponseReducer } from './app/state/item-configuration-input';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    // Provide Manually Created Stores
    provideStore({
        [projectsFeatureKey]: projectsReducer,
        [companiesFeatureKey]: companiesReducer,
        [productTypesFeatureKey]: productTypesReducer,
        [BrandsFeatureKey]: brandsReducer,
        [pricingInputsFeatureKey]: pricingInputsReducer,
        [pricingFormFeatureKey]: pricingFormReducer,
        [itemCodeStringValuesFeatureKey]: itemCodeStringValuesReducer,
        [itemConfigurationHeaderFeatureKey]: itemConfigurationHeaderReducer,
        [scheduleLineItemFeatureKey]: scheduleLineItemReducer,
        [itemConfigurationPerformanceFeatureKey]: itemConfigurationPerformanceReducer,
        [itemConfigurationPricingFeatureKey]: itemConfigurationPricingReducer,    
        [itemConfigurationInputRequestFeatureKey]: itemConfigurationInputRequestReducer,
        [itemConfigurationInputResponseFeatureKey]: itemConfigurationInputResponseReducer 
      }
    ),
    // Provide Manually Created Effects
    provideEffects(
      ProjectsEffects,
      CompaniesEffects,
      ProductTypesEffects,
      BrandsEffects,
      PricingInputsEffects,
      ItemConfigurationEffects,
      ItemConfigurationInputEffects
    ),
    // Provide Stores Created By `ng generate feature ...`
    //provideState(ProductVoltagesFeature),
    // Devtools for use with Redux Devtools Browser Extension
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: true, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true // If set to true, the connection is established within the Angular zone
    }),
    provideRouter(routes),
    //cns: https://angular.io/guide/http-intercept-requests-and-responses
    //modified to use httpInterceptorProviders for auth, logging, etc.
    //provideHttpClient(),
    importProvidersFrom(HttpClientModule, BrowserAnimationsModule,IonicModule.forRoot({}),NgIdleKeepaliveModule.forRoot()),
    httpInterceptorProviders
  ],
});
